import { Navigate, useLocation } from 'react-router-dom';
import { getToken as getAuthToken } from 'api/auth';

export default function RequireAdminAuth({ children }) {
  const location = useLocation();
  const token = getAuthToken({ admin: true });           // <-- use the same name you log

  // debug
  // eslint-disable-next-line no-console
  console.log('[RequireAdminAuth] token?', !!token, 'path=', location.pathname);

  if (!token) {
    // defensive: if this guard ever wraps the login route, don't bounce it
    if (location.pathname.endsWith('/admin/login')) return children;
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
